export default __webpack_public_path__ + "static/media/mobile_bg.d28ff209.png";